import React, { useState, useRef } from "react";
import ModalDrawer from "@/components/structure/ModalDrawer";
import PeekoutDrawer from "@/components/structure/PeekoutDrawer";

export default function Page() {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);

  // peekout drawer demo
  const [openDrawer, setOpenDrawer] = useState(false);
  const [comments, setComments] = useState<string[]>([
    'This is the first comment.',
    'Here is another comment.',
    'Great work on the project!',
    'Looking forward to more updates.',
    'Thanks for sharing your thoughts.'
  ]);
  const [commentInput, setCommentInput] = useState('');
  const drawerBtnRef = useRef(null);

  const appendComment = (comment: string) => {
    setComments([...comments, comment]);
    setCommentInput('');
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="mx-auto max-w-5xl px-4 py-8">
        <button
          ref={btnRef}
          onClick={() => setOpen(true)}
          className="rounded-md bg-black px-4 py-2 text-white hover:bg-black/90
                     focus:outline-none focus:ring-2 focus:ring-black/40 mr-2"
        >
          Open sidebar
        </button>

        <button
          ref={drawerBtnRef}
          onClick={() => setOpenDrawer(true)}
          className="rounded-md bg-black px-4 py-2 text-white hover:bg-black/90
                     focus:outline-none focus:ring-2 focus:ring-black/40"
        >
          Open bottom drawer
        </button>
      </header>

      <main className="mx-auto max-w-5xl px-4 pb-24">
        <p className="text-gray-700">
          Your page content goes here. When the drawer opens, the background will dim and
          scrolling will be locked.
        </p>
      </main>

      <ModalDrawer
        open={open}
        onClose={() => setOpen(false)}
        title="Settings"
        widthClass="w-full max-w-md" // responsive-friendly width
      >
        <form className="space-y-4">
          <label className="block">
            <span className="text-sm font-medium">Name</span>
            <input
              className="mt-1 w-full rounded-md border px-3 py-2 outline-none focus:ring-2 focus:ring-black/30"
              placeholder="Your name"
            />
          </label>
          <label className="block">
            <span className="text-sm font-medium">Email</span>
            <input
              type="email"
              className="mt-1 w-full rounded-md border px-3 py-2 outline-none focus:ring-2 focus:ring-black/30"
              placeholder="you@example.com"
            />
          </label>
          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              className="rounded-md px-4 py-2 hover:bg-gray-100"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
            <button
              className="rounded-md bg-black px-4 py-2 text-white hover:bg-black/90"
              onClick={() => setOpen(false)}
            >
              Save
            </button>
          </div>
        </form>
      </ModalDrawer>

      <PeekoutDrawer title="Comments" open={openDrawer} setOpen={setOpenDrawer} onClose={() => setOpenDrawer(false)}>
        <div className="p-4">
          <h3 className="text-lg font-medium mb-4">Comments</h3>
          <p className="text-sm text-gray-700">
            This is interactive content. Click inside, scroll, etc.
          </p>

          <ul className="mt-4 space-y-3">
            {comments.map((content, i) => (
              <li key={i} className="rounded-lg bg-gray-100 p-3 text-sm">
                {content}
              </li>
            ))}
          </ul>

          <div className="mt-4 flex gap-2">
            <input
              type="text"
              value={commentInput}
              onChange={(e) => setCommentInput(e.target.value)}
              className="flex-1 rounded-lg border border-gray-300 px-3 py-2 text-sm"
              placeholder="Add a comment…"
            />
            <button className="rounded-lg bg-black px-3 py-2 text-sm text-white" onClick={() => appendComment(commentInput)}>
              Send
            </button>
          </div>
        </div>
      </PeekoutDrawer>
    </div>
  );
}
